import { types } from './types';

const initialState = {
    list: {
        data: [],
        countPage: 0
    },
    view: null,
    user_widthdrawals: {
        data: [],
        count: 0
    },
    user_replenishment: {
        data: [],
        count: 0,
    },
    user_history_games: [],
    bonuses_history: {
        data: [],
        count: 0
    },
    last_operation: {
        data: [],
        count: 0
    },
    rezyme: {
        data: [],
        count: 0
    },
    bet: {
        data: [],
        count: 0
    },
    verification: [],
    list_jackpot: {
        data: [],
        countPage: 1,
    },
    freespin: {
        data: [],
        countPage: 1
    },
    user_logger: {
        data: [],
        countPage: 1
    },
    games: [],
    tags: [],
}

export function usersReducer(state = initialState, action) {
    switch (action.type) {
        case types.SET_USERS_LIST:
            return { ...state, list: action.payload };
        case types.SET_USER_BY_ID:
            return { ...state, view: action.payload };
        case types.SET_WITHDRAWALS_USER:
            return { ...state, user_widthdrawals: action.payload };
        case types.SET_REPLENISHMENT_USER:
            return { ...state, user_replenishment: action.payload };
        case types.SET_HISTORY_GAMES_USER:
            return { ...state, user_history_games: action.payload };
        case types.SET_BONUSES_HISTORY:
            return { ...state, bonuses_history: action.payload };
        case types.SET_LAST_OPERATION:
            return { ...state, last_operation: action.payload };
        case types.SET_REZYME:
            return { ...state, rezyme: action.payload };
        case types.SET_BET:
            return { ...state, bet: action.payload };
        case types.SET_VERIFICATION:
            return { ...state, verification: action.payload };
        case types.SET_HISTORY_LIST:
            return { ...state, list_jackpot: action.payload };
        case types.SET_FREESPIN_OPERATION:
            return { ...state, freespin: action.payload };
        case types.SET_USER_LOGGER:
            return { ...state, user_logger: action.payload };
        case types.SET_GAMES_LIST:
            return { ...state, games: action.payload };
        case types.SET_GET_TAGS:
            return { ...state, tags: action.payload };
        default:
            return state
    }
}